import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step,Dropzone} from '../components/Common';
import {Input,TextButton,Button,InputPhoto,MiniMinusButton} from '../components/Input';
import u from '../utilities/Utilities';
import {Photo} from '../data/Mimetypes';
import moment from 'moment';

export default class RewardItemList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Reward Items",
        permission:"reward",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/reward-item-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-reward-item-entry",
        deleteURL:"/api/delete-reward-item-entries",
        spreadsheetURL:"/api/generate-reward-item-spreadsheet",
        overviewURL:"/api/get-all-reward-item-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"reward-item-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                          index={index}
                                          content={content}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    onAddPhoto=async (filename)=>{
        try{
            const {content}=this.props;
            const response = await u.postAsync({
                url:"/api/reward-item-replace-photo",
                data:{
                    rewardID:content.rewardID,
                    userFilename:this.userFilename,
                    filename:filename,
                }
            });
            this.props.onChange(filename,"image",this.props.index);
            this.setState({loading:false,step:"view"});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    render=()=>{
        const {content,settings,permissions} = this.props;
        const canEdit= (permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>

                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel}
                                    permission={settings.permission}
                                    content={content}
                                    onChange={this.props.onChange}
                                    index={this.props.index}
                                    />

                    <div style={{position:"relative",margin:"30px auto 20px auto",textAlign:"center"}}>
                        <div className="list-image-container" style={{textAlign:"center"}}>
                            <h3>Item Photo</h3>
                            {
                                (content.image)
                                    ?
                                    <div className="list-image-container">
                                        <div className="list-image-item">
                                            <div className="list-image-flex">
                                                <img src={content.image} onClick={()=>{window.open(content.image,"_blank")}}/>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="list-placeholder">
                                        <h3>No Photo Added</h3>
                                        <div>Click below to add reward item photo</div>
                                    </div>
                            }
                        </div>

                        <div style={{margin:"10px auto",textAlign:"center"}}>
                            {
                                (canEdit)
                                    ?
                                    <TextButton onClick={()=>{this.setState({step:"add-attachment",error:""})}}>Add/Replace Photo</TextButton>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step=="add-attachment"} scroll={true}>
                    <div style={{fontSize:"14px",textAlign:"center"}}>
                        <h3>Add/Replace Item Photo</h3>
                        <Dropzone label={"Attachment"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddPhoto}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Photo}
                                  />

                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    settings={
        addType:0,
        addURL:"/api/create-reward-item-entry",
    };

    r={};

    state={
        step:"add",
        entryData:{},
        options:{},
        dormOptions:[],
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    componentDidMount=()=>{
        this.getDormOptions();
        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[]
                }
            });

            this.setState({options:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    getDormOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
                type:"dorm"
            },
            success:(dormOptions)=>{
                dormOptions.unshift({value:"All Users",label:"All Users"});
                dormOptions.unshift({value:"Staff Only",label:"Staff Only"});
                this.setState({dormOptions:dormOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        })
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        const {entryData}=this.state;
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...entryData,...data});
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                attachments:[],
            },
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onAddAttachment=(url)=>{
        let entryData=this.state.entryData;
        entryData.image=url;
        this.setState({entryData:entryData,step:"add",error:"",loading:false});
    }

    render=()=>{
        const {loading,loadText,step,options,entryData,dormOptions}=this.state;

        const fields=[
            {dataType:"select",label:"User Access",field:"dormID",options:dormOptions},
            {dataType:"box",label:"Item Name/Title",field:"item",rules:{required:true}},
            {dataType:"box",label:"Point Cost",field:"exchangePointCost",rules:{required:true},type:"number",info:"Number of points users must exchange to redeem this reward"},
            {dataType:"box",label:"Exchange Limit",field:"exchangeLimit",rules:{required:true},type:"number",info:"Maximum number of this item a single user can exchange in total lifetime"},
            {dataType:"box",label:"Inventory Quantity",field:"inventoryQuantity",rules:{required:true},type:"number",info:"Item will be shown as 'Temporarily Unavilable' in reward exchange page when quanity hits 0"},
            {dataType:"area",label:"Item Description",field:"description",rules:{required:true}},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create entry</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }

                        {
                            (entryData.image)
                                ?
                                <div style={{margin:"20px auto"}}>
                                    <img src={entryData.image} className='segment-photo' onClick={()=>{window.open(entryData.image,"__blank")}}/>
                                </div>
                                :
                                null
                        }

                        <div style={{margin:"20px auto",fontSize:"14px"}}>
                            <TextButton onClick={()=>{this.setState({step:"add-photo"})}}>Add/Replace Photo</TextButton>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="add-photo"}>
                        <Dropzone label={"Photo"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Photo}
                                  />

                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"add",error:""})}}>Back</Button>
                        </div>
                    </Step>
                </div>

            </AddListItem>
        )
    }
}

export class MiniRewardItemList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Reward Items",
        permission:"reward",  //Accepts combined permission module as well
        //combinedField:"",          //Used when permission exists in a combined field
        url:"/reward-item-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-reward-item-entry",
        deleteURL:"/api/delete-reward-item-entries",
        spreadsheetURL:"/api/generate-reward-item-spreadsheet",
        overviewURL:"/api/get-all-reward-item-entries",

        /**** List Setup ****/
        listLabel:"reward-item-list",
        orderByField:"createdOn",
        orderByType:"descending",
    };

    refresh=()=>{
        this.r['list'].refresh();
    }

    render=()=>{
        return(
            <MiniList ref={(ref)=>{this.r["list"]=ref}}
                      settings={this.settings}
                      tags={this.props.tags}
                      pageLength={this.props.pageLength}
                      orderByField={this.props.orderByField}
                      orderByType={this.props.orderByType}
                      addComponent={AddEntry}
                      addProps={this.props.addProps}
                      />
        )
    }
}